import React from "react";
import Marquee from "react-fast-marquee";
import { Box, Flex, Heading, Image } from "@chakra-ui/react";
import star from "../../assets/images/star.png";
const MarqueeBanner = () => {
  return (
    <Box my={{ base: 6, lg: 12 }} position="relative">
      <Box
        position="absolute"
        top={0}
        left={0}
        w="100%"
        h="100%"
        bg="brand.150"
        transform={{ base: "skewY(2deg)", lg: "skewY(0.8deg)" }}
      ></Box>

      <Marquee
        speed={50}
        gradient={false}
        style={{
          background: "rgba(215, 255, 66, 1)",
          padding: "8px 0",
          transform: "skewY(-0.5deg)", // Slant effect
          whiteSpace: "nowrap",
        }}
      >
        {[
          "THE BIG PICTURE",
          "THE NARRATIVE QUEST",
          "THE WRITERS GUILD",
          "STORY TELLING",
          "FILM MAKING",
          "CREATIVE WRITING",
        ].map((text, index) => (
          <Flex key={index} align="center" mx={4}>
            <Image src={star}></Image>
            <Heading
              fontWeight="bold"
              fontSize={{ base: "md", lg: "lg" }}
              mx={2}
            >
              {text}
            </Heading>
          </Flex>
        ))}
      </Marquee>
    </Box>
  );
};

export default MarqueeBanner;
